/**
 * Lightweight progress store (no Redux).
 * The axios interceptor writes here; the GlobalLoader reads here.
 */
const listeners = new Set();

let _state = {
  active: 0,        // number of in-flight requests
  upload: 0,        // 0-100 upload %
  uploadLoaded: 0,  // loaded bytes
  uploadTotal: 0,   // total bytes
  download: 0,      // 0-100 download %
  downloadLoaded: 0,// loaded bytes
  downloadTotal: 0, // total bytes
  label: '',        // optional label text
};

function notify() {
  listeners.forEach((fn) => fn({ ..._state }));
}

export const progressStore = {
  getState: () => ({ ..._state }),

  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  startRequest(label = '') {
    _state = { 
      ..._state, 
      active: _state.active + 1, 
      upload: 0, uploadLoaded: 0, uploadTotal: 0, 
      download: 0, downloadLoaded: 0, downloadTotal: 0, 
      label 
    };
    notify();
  },

  setUpload(pct, loaded = 0, total = 0) {
    _state = { ..._state, upload: Math.min(100, Math.round(pct)), uploadLoaded: loaded, uploadTotal: total };
    notify();
  },

  setDownload(pct, loaded = 0, total = 0) {
    _state = { ..._state, download: Math.min(100, Math.round(pct)), downloadLoaded: loaded, downloadTotal: total };
    notify();
  },

  endRequest() {
    const active = Math.max(0, _state.active - 1);
    _state = { ..._state, active, upload: active ? _state.upload : 0, download: active ? _state.download : 0 };
    notify();
  },
};
